import React, { useEffect, useState } from 'react'
import { CreateButton, GlobalLoader, Modal } from '@reactiveonline/reactive_admin_shared-packages'
import NoData from './accounting/NoData'

export default function ApiIntegrationsTab({
  apiIntegrationsData, createApiIntegrationPath, deleteApiIntegrationPath, flashMessageRef, getApiIntegrationsDataPath, loading, setApiIntegrationsData, setLoading
}) {
  const [showCreateModal, setShowCreateModal] = useState(false)

  useEffect(() => {
    if (!apiIntegrationsData) {
      setLoading(true)
      
      Rails.ajax({
        type: 'GET',
        url: getApiIntegrationsDataPath,
        dataType: 'json',
        success: res => {
          setApiIntegrationsData(res.apiIntegrationsData)
          setLoading(false)
        },
        error: res => {
          flashMessageRef.current.show(res.error, 'error')
          setLoading(false)
        }
      })
    }
  }, [])

  const handleDeleteIntegration = integrationId => {
    const fd = new FormData()

    fd.append('api_integration_id', integrationId)

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: deleteApiIntegrationPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message)
        
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  const handleCreate = integrationKey => {
    const fd = new FormData()

    fd.append('api', integrationKey)

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: createApiIntegrationPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message)
        setShowCreateModal(false)
        setApiIntegrationsData(res.apiIntegrationsData)
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      { !!apiIntegrationsData &&
        <>
          <div className='card'>
            <div className='card-content'>
              <div className='card-title m-b-20 flex-box items-center content-end'>
                { apiIntegrationsData.unusedApiIntegrations.length > 0 && 
                  <CreateButton
                    onClickCreate={ () => setShowCreateModal(true) } 
                    createTitle={ ReactiveCore.translations.create }
                  /> 
                }
              </div>

              <div className='card-body'>
                { !!apiIntegrationsData && !!apiIntegrationsData.apiIntegrations?.length
                  ? <table className='responsive-table'>
                      <thead>
                        <tr>
                          <th>API</th>
                        </tr>
                      </thead>
                      <tbody>
                        { apiIntegrationsData.apiIntegrations.map((apiIntegration, idx) => (
                          <tr key={ idx }>
                            <td>
                              { apiIntegration.api_entity.charAt(0).toUpperCase() + apiIntegration.api_entity.slice(1) }
                            </td>
                            <td className="right flex-box items-center">
                              { apiIntegration.canDelete &&
                                <i 
                                  className='fa-light fa-trash' 
                                  style={{ cursor: 'pointer' }}
                                  onClick={ _e => handleDeleteIntegration(apiIntegration.id) }
                                />
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  : <NoData />
                }
              </div>
            </div>
          </div>

          { showCreateModal &&
            <Modal
              visible
              closeModal={ () => setShowCreateModal(false) }
              mode="large"
            >
              <div className='flex-box flex-column content-center' style={{ width: '100%' }}>
                <>
                  <div className='title bold'>
                    { ReactiveCore.translations.available_api_integration_options }
                  </div>
                  <div className='flex-box flex-wrap m-t-20' style={{ width: '100%', rowGap: 20 }}>
                    { apiIntegrationsData.unusedApiIntegrations.map((apiIntegration, index) => (
                      <div 
                        key={ index } 
                        className='flex-box items-center content-center m-r-20' 
                        style={{ width: '35%' }}
                      >
                        <button
                          type='button'
                          className='btn reverted flex-box flex-column items-center content-space-between'
                          style={{ width: '100%', minHeight: 200, padding: '50px 20px', lineHeight: '1.5em' }}
                          onClick={ _e => handleCreate(apiIntegration.key) }
                        >
                          <div>
                            <i 
                              className={ `fa-light ${ apiIntegration.icon }` } 
                              style={{ fontSize: 45 }} 
                            />
                            <div className='m-t-20 bold'>
                              { apiIntegration.title }
                            </div>
                          </div>
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              </div>

              { loading && <GlobalLoader fullPage /> }
            </Modal>
          }
        </>
      }
    </>
  )
}